import { Component, OnInit } from '@angular/core';
import { EMPTY, Subscription } from 'rxjs';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { ReportsTurnsService } from 'src/app/services/turns-services/reports-turns-service/reports-turns.service';
import { HeaderBreadcrumbService } from 'src/app/components/header-components/header-breadcrumb/header-breadcrumb.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { tap } from 'rxjs/internal/operators/tap';
import { catchError } from 'rxjs/internal/operators/catchError';
import { DashboardService } from 'src/app/services/dashboard-services/dashboard.service';
import { DashboardBroadcastService } from 'src/app/services/dashboard-services/dashboard-broadcast-service/dashboard-broadcast.service';
import { NotificationsService } from 'src/app/services/notifications-services/notifications.service';

@Component({
  selector: 'app-dashboard-broadcast',
  templateUrl: './dashboard-broadcast.component.html',
  styleUrls: ['./dashboard-broadcast.component.scss']
})
export class DashboardBroadcastComponent implements OnInit {

  centers;
  selectedCenters = [];
  from;
  to;

  activityData;
  totalPlayback;
  playbackAverage;

  notifications;
  connectivityData;
  noItemsConfig;

  getDevicesSubscription: Subscription;
  dashboardServiceSubscription: Subscription;
  getActivitySubscription: Subscription;

  reportMessage = '';
  disableReportButton = false;

  constructor(
    private reportsTurnsService: ReportsTurnsService,
    private userStorageService: UserStorageService,
    private headerBreadcrumbService: HeaderBreadcrumbService,
    private dashboardService: DashboardService,
    private dashboardBroadcastService: DashboardBroadcastService,
    private notificationsService: NotificationsService,
    private snackbarService: SnackBarService) {
      this.centers = this.userStorageService.getCenterList();
      this.noItemsConfig = this.setNoItemsConfig();
    }

  ngOnInit() {
    this.selectedCenters = [this.centers[0]];
    this.setBreadcrumb();
    this.getNotifications();
    if (this.dashboardServiceSubscription) { this.dashboardServiceSubscription.unsubscribe(); }
    this.dashboardServiceSubscription = this.dashboardService.listenReloadStatistics().pipe(
      tap(o => this.selectedCenters = o['centers']),
      tap(o => this.from = o['from'].valueOf()),
      tap(o => this.to = o['to'].valueOf()),
      tap(o => this.loadData())
    ).subscribe();
    this.notificationsService.listenNotifications().subscribe(
      (res) => {
        console.log('Receive notification event');
        this.getNotifications();
      }
    );
  }

  private loadData() {
    // this.connectivityData = null;
    // this.getConnectivityTime(this.centers[6], new Date().valueOf(), new Date().valueOf());
    this.activityData = null;
    this.totalPlayback = null;
    this.playbackAverage = null;
    this.getActivity();
  }

  private getActivity() {
    const centerInternalIdList = this.selectedCenters.map( center => center.InternalId );
    this.getActivitySubscription = this.dashboardBroadcastService.getActivity(
      this.from,
      this.to,
      centerInternalIdList
    ).pipe(
      tap(o => this.manageResponse(o)),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
    ).subscribe();
  }

  private manageResponse(o) {
    this.activityData = o;
    this.totalPlayback = (this.activityData.sumPlaybackSeconds / (3600)).toFixed(1).toString() + 'h';
    this.playbackAverage = (this.activityData.averageActivity / (3600)).toFixed(1).toString() + 'h';
  }

  private getConnectivityTime(center, from, to) {
    this.reportsTurnsService.waitingTimePerDesk(from, to, [center.InternalId]).pipe(
      tap((turnsWaitingTime) => {
          this.connectivityData = turnsWaitingTime;
      })
    ).subscribe();
  }

  generateReport() {
    this.reportMessage = 'dashboard-broadcast-page.report wait';
    const centerInternalIdList = this.selectedCenters.map( center => center.InternalId );
    this.dashboardBroadcastService.getActivityDetails(
      this.from,
      this.to,
      centerInternalIdList
    ).pipe(
      tap(o => {
        if (o === true) {
          this.reportMessage = 'dashboard-broadcast-page.report generating';
        } else {
          this.reportMessage = 'dashboard-broadcast-page.report error';
        }
        this.getNotifications();
      }),
      catchError(error => {
        this.reportMessage = 'dashboard-broadcast-page.report error';
        this.snackbarService.open(error['error']['message'], 'error');
        return EMPTY;
      })
    ).subscribe();
  }

  private getNotifications() {
    this.notificationsService.getNotifications().pipe(
      tap((o) => {
          this.notifications = o.filter( n => n.typeProcess === 'BROADCASTING_ACTITITY').slice(0, 8);
      })
    ).subscribe();
  }

  public downloadNotification(notification) {
    if (notification.url !== undefined && notification.url !== null) {
      const action = 'window.open("' + notification.url + '");';
      eval(action);
    }
  }

  getStatus(status) {
    if (status === 'IN_PROGRESS') {
      return 'En Progreso';
    } else if (status === 'RECEIVED') {
      return 'Recibido';
    } else if (status === 'FINISHED') {
      return 'Finalizado';
    }
  }

  updateNotifications() {
    this.reportMessage = '';
    this.getNotifications();
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-th', 'breadcrumb-title.dashboard broadcast'));
  }

  private setNoItemsConfig() {
    return {
      description: 'dashboard-page.selected centers not found',
      action: '',
      lottieConfig: {
        path: 'assets/lottie-animations/empty-list.json',
        renderer: 'canvas',
        autoplay: true,
        loop: true
      }
    };
  }

}
